import React, { useState,useEffect } from "react";
import StadoPayrollFooter from "./StadoPayrollFooter";

export default function ContactSupport() {
  
  return (
    <>
      <section className="relative bg-[#050505] text-gray-200 py-12 md:py-24 px-4 overflow-hidden font-sans">
        
        {/* Soft Brand Glow Effects - Adjusted for mobile view */}
        <div className="pointer-events-none absolute -top-20 left-10 w-[300px] h-[300px] md:w-[420px] md:h-[420px] rounded-full bg-[#f68c51]/10 blur-[120px] md:blur-[160px]" />
        <div className="pointer-events-none absolute bottom-0 right-10 w-[300px] h-[300px] md:w-[420px] md:h-[420px] rounded-full bg-[#fd2c55]/10 blur-[120px] md:blur-[160px]" />

        <div className="relative max-w-5xl mx-auto space-y-10 md:space-y-16">
          
          {/* HEADER SECTION */}
          <div className="text-center px-2">
            <h1 className="text-4xl md:text-6xl font-bold text-white tracking-tight">
              Get in <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#f68c51] to-[#fd2c55]">Touch</span>
            </h1>
            <div className="mt-4 h-[3px] w-16 md:w-24 mx-auto rounded-full bg-gradient-to-r from-[#f68c51] to-[#fd2c55]" />
            <p className="mt-6 text-gray-400 text-sm md:text-lg max-w-xl mx-auto italic leading-relaxed">
              "Providing seamless HRMS & Payroll assistance across all business hours."
            </p>
          </div>

          {/* MAIN CONTENT GRID */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-10 items-stretch">
            
            {/* LEFT: CONTACT INFO */}
            <div className="flex flex-col">
              <div className="bg-white/5 p-6 md:p-10 rounded-[2rem] border border-white/10 backdrop-blur-md h-full flex flex-col justify-center transition-all hover:bg-white/[0.07]">
                <h2 className="text-xl md:text-2xl font-semibold text-white mb-8 flex items-center gap-3">
                  <span className="w-1.5 h-6 bg-[#f68c51] rounded-full"></span>
                  Direct Channels
                </h2>
                
                <div className="space-y-8">
                  {/* Email Channel */}
                  <div className="group flex flex-col sm:flex-row items-start sm:items-center gap-4 transition-transform hover:translate-x-1">
                    <div className="w-12 h-12 shrink-0 rounded-2xl bg-gradient-to-br from-[#f68c51] to-[#fd2c55] flex items-center justify-center shadow-lg shadow-[#fd2c55]/20">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <div className="overflow-hidden">
                      <p className="text-[10px] md:text-xs text-gray-500 uppercase tracking-[0.2em] font-bold mb-1">Priority Email</p>
                      <a href="mailto:support@stadoworld.com" className="text-base md:text-xl font-medium text-white hover:text-[#f68c51] transition-colors break-all">
                        support@stadoworld.com
                      </a>
                    </div>
                  </div>

                  {/* Website Channel */}
                  <div className="group flex flex-col sm:flex-row items-start sm:items-center gap-4 transition-transform hover:translate-x-1">
                    <div className="w-12 h-12 shrink-0 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center group-hover:border-[#fd2c55]/50 transition-colors">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-[#fd2c55]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                      </svg>
                    </div>
                    <div className="overflow-hidden">
                      <p className="text-[10px] md:text-xs text-gray-500 uppercase tracking-[0.2em] font-bold mb-1">Cloud Dashboard</p>
                      <a href="https://payroll.stadoworld.com" target="_blank" rel="noreferrer" className="text-base md:text-xl font-medium text-white hover:text-[#fd2c55] transition-colors break-all">
                        payroll.stadoworld.com
                      </a>
                    </div>
                  </div>
                </div>

                <div className="mt-10 p-5 border-l-2 border-[#f68c51] bg-white/5 rounded-r-2xl italic text-gray-400 text-sm leading-relaxed">
                  "Our specialists usually respond within 24 business hours."
                </div>
              </div>
            </div>

            {/* RIGHT: SUPPORT HIGHLIGHTS */}
            <div className="bg-gradient-to-br from-white/10 to-transparent p-[1px] rounded-[2rem]">
                <div className="bg-[#0a0a0a]/90 backdrop-blur-sm p-6 md:p-10 rounded-[1.95rem] h-full">
                    <h2 className="text-xl md:text-2xl font-semibold text-white mb-8">Support Coverage</h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4">
                        {[
                            { title: "Technical Assistance", desc: "Configuration & cloud deployment help." },
                            { title: "Payroll Processing", desc: "Calculation & disbursement support." },
                            { title: "Integration Support", desc: "API and third-party sync assistance." },
                            { title: "Security & Access", desc: "Account recovery and permissions." }
                        ].map((item, index) => (
                            <div key={index} className="p-5 rounded-2xl bg-white/5 border border-white/5 hover:border-[#f68c51]/30 transition-all group">
                                <h3 className="text-[#f68c51] font-bold text-sm mb-1 group-hover:text-white transition-colors">{item.title}</h3>
                                <p className="text-gray-400 text-xs leading-relaxed">{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
          </div>

          {/* FOOTER STATUS BOX */}
          <div className="max-w-2xl mx-auto text-center px-4">
             <div className="inline-flex items-center gap-3 px-8 py-3 rounded-full bg-white/5 border border-white/10 text-xs md:text-sm text-gray-300 backdrop-blur-sm">
                <span className="relative flex h-2.5 w-2.5">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500"></span>
                </span>
                Live Support: <span className="text-white font-medium italic">Monday - Saturday (9AM - 7PM)</span>
             </div>
          </div>

          <footer className="text-center pt-10 text-gray-600 text-[10px] md:text-xs uppercase tracking-[0.3em] font-medium">
            Stado Payroll &bull; Corporate Support Division
          </footer>

        </div>
      </section>
      <StadoPayrollFooter />
    </>
  );
}